

// 微信支付方法（点击按键调用）
const wx = window.jWeixin || require('weixin-js-sdk')

/**
 * 微信支付方法
 * 获取微信加签信息
 * @param{data}:获取的微信加签
 * @param{cb}:成功回调
 */
const wxPay = (data, callback) => {
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.paySign, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
    wx.ready(function() {
        wx.chooseWXPay({
            timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
            package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.paySign, // 支付签名
            success: function(res) {
                callback && callback({
                    type: 'success'
                })
            },
            fail: function(res) {
                console.log(res)
            }
        })
    })
    wx.error((err) => {
        console.log(err)
    })
}

/**
 * 获取支付环境
 */
const payWayWeiXin = () => {
    var ua = navigator.userAgent.toLowerCase();
    let isWx = ua.match(/MicroMessenger/i) == "micromessenger";
    if (isWx) {
        let isWxWork = ua.match(/WxWork/i) == "wxwork";
        if (!isWxWork) {
            // 微信内浏览器
            return 'wechat';
        } else {
            // 企业微信浏览器
            return 'work_wechat';
        }
    } else {
        // web浏览器
        return 'wx_h5';
    }
}

/**
 * 支付宝支付
 * @author Meng
 * @dateTime 2021-11-16
 * @param    {[type]}   paySign [description]
 * @return   {[type]}           [description]
 */
const aliPay = (paySign) => {
    if (!paySign) return false;
    const div = document.createElement('div');
    // 此处form就是后台返回接收到的数据
    div.innerHTML = paySign;
    document.body.appendChild(div);
    document.forms[0].submit();
}

export {
    wxPay,
    aliPay,
    payWayWeiXin
}